import { Switchboard } from "../../lib/events";
import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class BufferSearchButton extends ToolbarButton {
    constructor(b_layer) {
        super('expand-arrows-alt', 'Buffer Search', 'bsButton');
        this.b_layer = b_layer;
        this.err_receiver = Switchboard.get_receiver("BUFFER_ERR");
        this.setupErrorListener();
    }
    _action() {
        this.b_layer.clear();
        this.b_layer.show();
    }
    setupErrorListener() {
        this.err_receiver.on("buffer_err", () => {
            this.ui.removeClass("highlighted");
            this.ui.blur();
            this.ui.prop("disabled", true);
        });
    }
    ;
}
